import { useMutation } from '@apollo/client';
import type { DeleteEntityMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteEntityDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteEntityTRPC } from './useDeleteEntityTRPC';

export const useDeleteEntity = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  // GraphQL mutation (legacy)
  const [deleteEntityGraphQL, graphqlState] = useMutation(
    DeleteEntityDocument,
    {
      update: (cache) => {
        evictField(cache, 'entity');
        evictField(cache, 'entity_by_pk');
      },
    }
  );

  // tRPC mutation
  const trpcMutation = useDeleteEntityTRPC();

  const deleteEntity = async (variables: {
    Id: string;
  }): Promise<DeleteEntityMutation> => {
    if (trpcEnabled) {
      return trpcMutation.deleteEntity({ Id: variables.Id });
    }

    const result = await deleteEntityGraphQL({
      variables: { Id: variables.Id },
    });
    if (!result.data) {
      throw new Error('Failed to delete entity');
    }

    return result.data;
  };

  return {
    deleteEntity,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
